/* eslint-disable no-console */
import axios from 'axios';
import moment from 'moment';

import {RefriKey} from '../../../components/Forms/Constants/IP/RefriKeyLabel';
import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {getRouteIP, tableAPIMethod} from '../../utils/tableAPIMethod';

const fugitiveAPI = async (
  type: APIType,
  data: any = undefined,
  id: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;
  if (type === APITypeEnum.PUT) {
    delete data.company;
  }
  try {
    const response = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.fugitive}/${getRouteIP(
        type,
        id
      )}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });

    if (type === APITypeEnum.GET_ALL) {
      const mainRes = response?.data?.data?.map((item: any) => {
        return {
          ...item,
          [RefriKey.DATE_INSTALLATION]: item?.[RefriKey.DATE_INSTALLATION]
            ? moment(item?.[RefriKey.DATE_INSTALLATION])
            : undefined
        };
      });

      return mainRes;
    } else {
      return response.data;
    }
  } catch (err) {
    console.log('err:', err);
  }
};

export default fugitiveAPI;
